// Pays (ISO 3166) : [code, nom anglais (inscrit sur la facture), nom français (recherche)].
// Liste générée une fois (Intl.DisplayNames), sans dépendance.
export const PAYS = [
  ["AF","Afghanistan","Afghanistan"],
  ["AX","Åland Islands","Îles Åland"],
  ["AL","Albania","Albanie"],
  ["DZ","Algeria","Algérie"],
  ["AS","American Samoa","Samoa américaines"],
  ["AD","Andorra","Andorre"],
  ["AO","Angola","Angola"],
  ["AI","Anguilla","Anguilla"],
  ["AQ","Antarctica","Antarctique"],
  ["AG","Antigua & Barbuda","Antigua-et-Barbuda"],
  ["AR","Argentina","Argentine"],
  ["AM","Armenia","Arménie"],
  ["AW","Aruba","Aruba"],
  ["AU","Australia","Australie"],
  ["AT","Austria","Autriche"],
  ["AZ","Azerbaijan","Azerbaïdjan"],
  ["BS","Bahamas","Bahamas"],
  ["BH","Bahrain","Bahreïn"],
  ["BD","Bangladesh","Bangladesh"],
  ["BB","Barbados","Barbade"],
  ["BY","Belarus","Biélorussie"],
  ["BE","Belgium","Belgique"],
  ["BZ","Belize","Belize"],
  ["BJ","Benin","Bénin"],
  ["BM","Bermuda","Bermudes"],
  ["BT","Bhutan","Bhoutan"],
  ["BO","Bolivia","Bolivie"],
  ["BA","Bosnia & Herzegovina","Bosnie-Herzégovine"],
  ["BW","Botswana","Botswana"],
  ["BV","Bouvet Island","Île Bouvet"],
  ["BR","Brazil","Brésil"],
  ["IO","British Indian Ocean Territory","Territoire britannique de l’océan Indien"],
  ["VG","British Virgin Islands","Îles Vierges britanniques"],
  ["BN","Brunei","Brunei"],
  ["BG","Bulgaria","Bulgarie"],
  ["BF","Burkina Faso","Burkina Faso"],
  ["BI","Burundi","Burundi"],
  ["KH","Cambodia","Cambodge"],
  ["CM","Cameroon","Cameroun"],
  ["CA","Canada","Canada"],
  ["CV","Cape Verde","Cap-Vert"],
  ["BQ","Caribbean Netherlands","Pays-Bas caribéens"],
  ["KY","Cayman Islands","Îles Caïmans"],
  ["CF","Central African Republic","République centrafricaine"],
  ["TD","Chad","Tchad"],
  ["CL","Chile","Chili"],
  ["CN","China","Chine"],
  ["CX","Christmas Island","Île Christmas"],
  ["CC","Cocos (Keeling) Islands","Îles Cocos"],
  ["CO","Colombia","Colombie"],
  ["KM","Comoros","Comores"],
  ["CG","Congo - Brazzaville","Congo-Brazzaville"],
  ["CD","Congo - Kinshasa","Congo-Kinshasa"],
  ["CK","Cook Islands","Îles Cook"],
  ["CR","Costa Rica","Costa Rica"],
  ["CI","Côte d’Ivoire","Côte d’Ivoire"],
  ["HR","Croatia","Croatie"],
  ["CU","Cuba","Cuba"],
  ["CW","Curaçao","Curaçao"],
  ["CY","Cyprus","Chypre"],
  ["CZ","Czechia","Tchéquie"],
  ["DK","Denmark","Danemark"],
  ["DJ","Djibouti","Djibouti"],
  ["DM","Dominica","Dominique"],
  ["DO","Dominican Republic","République dominicaine"],
  ["EC","Ecuador","Équateur"],
  ["EG","Egypt","Égypte"],
  ["SV","El Salvador","Salvador"],
  ["GQ","Equatorial Guinea","Guinée équatoriale"],
  ["ER","Eritrea","Érythrée"],
  ["EE","Estonia","Estonie"],
  ["SZ","Eswatini","Eswatini"],
  ["ET","Ethiopia","Éthiopie"],
  ["FK","Falkland Islands","Îles Malouines"],
  ["FO","Faroe Islands","Îles Féroé"],
  ["FJ","Fiji","Fidji"],
  ["FI","Finland","Finlande"],
  ["FR","France","France"],
  ["GF","French Guiana","Guyane française"],
  ["PF","French Polynesia","Polynésie française"],
  ["TF","French Southern Territories","Terres australes françaises"],
  ["GA","Gabon","Gabon"],
  ["GM","Gambia","Gambie"],
  ["GE","Georgia","Géorgie"],
  ["DE","Germany","Allemagne"],
  ["GH","Ghana","Ghana"],
  ["GI","Gibraltar","Gibraltar"],
  ["GR","Greece","Grèce"],
  ["GL","Greenland","Groenland"],
  ["GD","Grenada","Grenade"],
  ["GP","Guadeloupe","Guadeloupe"],
  ["GU","Guam","Guam"],
  ["GT","Guatemala","Guatemala"],
  ["GG","Guernsey","Guernesey"],
  ["GN","Guinea","Guinée"],
  ["GW","Guinea-Bissau","Guinée-Bissau"],
  ["GY","Guyana","Guyana"],
  ["HT","Haiti","Haïti"],
  ["HM","Heard & McDonald Islands","Îles Heard-et-MacDonald"],
  ["HN","Honduras","Honduras"],
  ["HK","Hong Kong SAR China","R.A.S. chinoise de Hong Kong"],
  ["HU","Hungary","Hongrie"],
  ["IS","Iceland","Islande"],
  ["IN","India","Inde"],
  ["ID","Indonesia","Indonésie"],
  ["IR","Iran","Iran"],
  ["IQ","Iraq","Irak"],
  ["IE","Ireland","Irlande"],
  ["IM","Isle of Man","Île de Man"],
  ["IL","Israel","Israël"],
  ["IT","Italy","Italie"],
  ["JM","Jamaica","Jamaïque"],
  ["JP","Japan","Japon"],
  ["JE","Jersey","Jersey"],
  ["JO","Jordan","Jordanie"],
  ["KZ","Kazakhstan","Kazakhstan"],
  ["KE","Kenya","Kenya"],
  ["KI","Kiribati","Kiribati"],
  ["XK","Kosovo","Kosovo"],
  ["KW","Kuwait","Koweït"],
  ["KG","Kyrgyzstan","Kirghizstan"],
  ["LA","Laos","Laos"],
  ["LV","Latvia","Lettonie"],
  ["LB","Lebanon","Liban"],
  ["LS","Lesotho","Lesotho"],
  ["LR","Liberia","Liberia"],
  ["LY","Libya","Libye"],
  ["LI","Liechtenstein","Liechtenstein"],
  ["LT","Lithuania","Lituanie"],
  ["LU","Luxembourg","Luxembourg"],
  ["MO","Macao SAR China","R.A.S. chinoise de Macao"],
  ["MG","Madagascar","Madagascar"],
  ["MW","Malawi","Malawi"],
  ["MY","Malaysia","Malaisie"],
  ["MV","Maldives","Maldives"],
  ["ML","Mali","Mali"],
  ["MT","Malta","Malte"],
  ["MH","Marshall Islands","Îles Marshall"],
  ["MQ","Martinique","Martinique"],
  ["MR","Mauritania","Mauritanie"],
  ["MU","Mauritius","Maurice"],
  ["YT","Mayotte","Mayotte"],
  ["MX","Mexico","Mexique"],
  ["FM","Micronesia","Micronésie"],
  ["MD","Moldova","Moldavie"],
  ["MC","Monaco","Monaco"],
  ["MN","Mongolia","Mongolie"],
  ["ME","Montenegro","Monténégro"],
  ["MS","Montserrat","Montserrat"],
  ["MA","Morocco","Maroc"],
  ["MZ","Mozambique","Mozambique"],
  ["MM","Myanmar (Burma)","Myanmar (Birmanie)"],
  ["NA","Namibia","Namibie"],
  ["NR","Nauru","Nauru"],
  ["NP","Nepal","Népal"],
  ["NL","Netherlands","Pays-Bas"],
  ["NC","New Caledonia","Nouvelle-Calédonie"],
  ["NZ","New Zealand","Nouvelle-Zélande"],
  ["NI","Nicaragua","Nicaragua"],
  ["NE","Niger","Niger"],
  ["NG","Nigeria","Nigeria"],
  ["NU","Niue","Niue"],
  ["NF","Norfolk Island","Île Norfolk"],
  ["KP","North Korea","Corée du Nord"],
  ["MK","North Macedonia","Macédoine du Nord"],
  ["MP","Northern Mariana Islands","Îles Mariannes du Nord"],
  ["NO","Norway","Norvège"],
  ["OM","Oman","Oman"],
  ["PK","Pakistan","Pakistan"],
  ["PW","Palau","Palaos"],
  ["PS","Palestinian Territories","Territoires palestiniens"],
  ["PA","Panama","Panama"],
  ["PG","Papua New Guinea","Papouasie-Nouvelle-Guinée"],
  ["PY","Paraguay","Paraguay"],
  ["PE","Peru","Pérou"],
  ["PH","Philippines","Philippines"],
  ["PN","Pitcairn Islands","Îles Pitcairn"],
  ["PL","Poland","Pologne"],
  ["PT","Portugal","Portugal"],
  ["PR","Puerto Rico","Porto Rico"],
  ["QA","Qatar","Qatar"],
  ["RE","Réunion","La Réunion"],
  ["RO","Romania","Roumanie"],
  ["RU","Russia","Russie"],
  ["RW","Rwanda","Rwanda"],
  ["WS","Samoa","Samoa"],
  ["SM","San Marino","Saint-Marin"],
  ["ST","São Tomé & Príncipe","Sao Tomé-et-Principe"],
  ["SA","Saudi Arabia","Arabie saoudite"],
  ["SN","Senegal","Sénégal"],
  ["RS","Serbia","Serbie"],
  ["SC","Seychelles","Seychelles"],
  ["SL","Sierra Leone","Sierra Leone"],
  ["SG","Singapore","Singapour"],
  ["SX","Sint Maarten","Saint-Martin (partie néerlandaise)"],
  ["SK","Slovakia","Slovaquie"],
  ["SI","Slovenia","Slovénie"],
  ["SB","Solomon Islands","Îles Salomon"],
  ["SO","Somalia","Somalie"],
  ["ZA","South Africa","Afrique du Sud"],
  ["GS","South Georgia & South Sandwich Islands","Géorgie du Sud-et-les Îles Sandwich du Sud"],
  ["KR","South Korea","Corée du Sud"],
  ["SS","South Sudan","Soudan du Sud"],
  ["ES","Spain","Espagne"],
  ["LK","Sri Lanka","Sri Lanka"],
  ["BL","St. Barthélemy","Saint-Barthélemy"],
  ["SH","St. Helena","Sainte-Hélène"],
  ["KN","St. Kitts & Nevis","Saint-Christophe-et-Niévès"],
  ["LC","St. Lucia","Sainte-Lucie"],
  ["MF","St. Martin","Saint-Martin"],
  ["PM","St. Pierre & Miquelon","Saint-Pierre-et-Miquelon"],
  ["VC","St. Vincent & Grenadines","Saint-Vincent-et-les Grenadines"],
  ["SD","Sudan","Soudan"],
  ["SR","Suriname","Suriname"],
  ["SJ","Svalbard & Jan Mayen","Svalbard et Jan Mayen"],
  ["SE","Sweden","Suède"],
  ["CH","Switzerland","Suisse"],
  ["SY","Syria","Syrie"],
  ["TW","Taiwan","Taïwan"],
  ["TJ","Tajikistan","Tadjikistan"],
  ["TZ","Tanzania","Tanzanie"],
  ["TH","Thailand","Thaïlande"],
  ["TL","Timor-Leste","Timor oriental"],
  ["TG","Togo","Togo"],
  ["TK","Tokelau","Tokelau"],
  ["TO","Tonga","Tonga"],
  ["TT","Trinidad & Tobago","Trinité-et-Tobago"],
  ["TN","Tunisia","Tunisie"],
  ["TR","Türkiye","Turquie"],
  ["TM","Turkmenistan","Turkménistan"],
  ["TC","Turks & Caicos Islands","Îles Turques-et-Caïques"],
  ["TV","Tuvalu","Tuvalu"],
  ["UM","U.S. Outlying Islands","Îles mineures éloignées des États-Unis"],
  ["VI","U.S. Virgin Islands","Îles Vierges des États-Unis"],
  ["UG","Uganda","Ouganda"],
  ["UA","Ukraine","Ukraine"],
  ["AE","United Arab Emirates","Émirats arabes unis"],
  ["GB","United Kingdom","Royaume-Uni"],
  ["US","United States","États-Unis"],
  ["UY","Uruguay","Uruguay"],
  ["UZ","Uzbekistan","Ouzbékistan"],
  ["VU","Vanuatu","Vanuatu"],
  ["VA","Vatican City","État de la Cité du Vatican"],
  ["VE","Venezuela","Venezuela"],
  ["VN","Vietnam","Viêt Nam"],
  ["WF","Wallis & Futuna","Wallis-et-Futuna"],
  ["EH","Western Sahara","Sahara occidental"],
  ["YE","Yemen","Yémen"],
  ["ZM","Zambia","Zambie"],
  ["ZW","Zimbabwe","Zimbabwe" ],
];

const sans = (s) => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

/** Pays qui correspondent à la recherche (anglais, français ou code). */
export function chercherPays(q) {
  const t = sans(q).trim();
  if (!t) return PAYS;
  return PAYS.filter(([c, en, fr]) => sans(en).includes(t) || sans(fr).includes(t) || c.toLowerCase() === t)
    .sort((a, b) => (sans(a[1]).startsWith(t) || sans(a[2]).startsWith(t) ? 0 : 1) - (sans(b[1]).startsWith(t) || sans(b[2]).startsWith(t) ? 0 : 1));
}

/** Nom français d'un pays saisi en anglais (aide à la lecture). */
export const nomFrancais = (en) => PAYS.find((p) => p[1] === en)?.[2] || "";

const cleNom = (s) => sans(s).replace(/[^a-z0-9]/g, "");
const ALIAS = { angleterre: "GB", ecosse: "GB", uk: "GB", grandebretagne: "GB", usa: "US", etatsunis: "US", amerique: "US",
  hollande: "NL", coreedusud: "KR", russie: "RU", tchequie: "CZ", republiquetcheque: "CZ" };

/** Nom anglais d'un pays saisi en français, en anglais ou par son code
 *  (« Royaume-Uni », « royaume uni », « GB » -> « United Kingdom »).
 *  Texte inconnu : rendu tel quel. */
export function paysEnAnglais(v) {
  const k = cleNom(v);
  if (!k) return v || "";
  const p = PAYS.find(([c, en, fr]) => cleNom(en) === k || cleNom(fr) === k || c.toLowerCase() === k)
    || (ALIAS[k] && PAYS.find(([c]) => c === ALIAS[k]));
  return p ? p[1] : v;
}
